import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'pascalSpaces'})
export class PascalSpaces implements PipeTransform {
  transform(value: string): string {
    return value? value.replace(/([A-Z])/g, ' $1').trim() : value;
  }
}
